import styled from "styled-components";

const CommentsStyled = styled.div``;

export default CommentsStyled;
